<div
  [attr.aria-label]="'Elapsed time' | translate"
  class="clock fx-row fx-align-center fx-justify-start"
>
  @if (!!hours) {
  <div>{{ hours }}</div>
  <div>:</div>
  }
  <div>{{ minutes }}</div>
  <div [class.not-visible]="secondOff">:</div>
  <div>{{ seconds }}</div>
</div>
